package org.hs_soft.runmynesto.pages.home.sub_page.product.component

import androidx.compose.runtime.Composable

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.dialog.AddRecordDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ErrorMsgDialog
import org.hs_soft.runmynesto.pages.components.dialog.dialog.ImageAIDialog
import org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs.DeleteDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component.AddingCustomAllergeneDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component.CreateCustomAllergeneDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab.component.AddPriceDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.restaurant_tab.component.KitchenAddItemDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components.AddNewProductSetDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components.AddOrEditFixedProductDialog
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductState

@Composable
fun ProductDialogs(
    state: ProductState,
    windowSizeMode: WindowSizeModeEnum,
    event: (ProductEvent) -> Unit
) {
    if (state.showGenerateAIImgDialog) {
        ImageAIDialog(
            windowSizeMode = windowSizeMode,
            isSubmitClickable = state.imageAiGeneratorDescription?.isNotEmpty() == true
                    && state.cashBidImgAIGeneratorUrl!=null,
            id = state.selectedProduct?.id ?: "",
            description = state.imageAiGeneratorDescription?:"",
            submitGeneratedImgLoading = state.submitGeneratedImgLoading,
            generateImgLoading = state.isImageAiGeneratorLoading,
            imgGeneratedUrl = state.cashBidImgAIGeneratorUrl,
            onDescriptionInputChange = {
                event(ProductEvent.OnChangeAiImageDescription(it))
            },
            onBackgroundClick = {
                event(ProductEvent.SetGenerateCashBidAIImgDialogStatus(false))
            },
            onCancelClick = {
                event(ProductEvent.SetGenerateCashBidAIImgDialogStatus(false))
            },
            onSubmitClick = { id, imgAiGeneratorUrl ->
                event(
                    ProductEvent.OnSelectCashBidImg(
                        id = id,
                        url = imgAiGeneratorUrl,
                    )
                )
            },
            onGenerateImgClick = { desc ->
                event(
                    ProductEvent.GenerateProductCashBidImg(
                        description = desc,
                    )
                )
            },
            onSelectImg = {url:String->
                event(
                    ProductEvent.SetLocalCashBidImg(
                        url = url,
                    ))
            }

        )
    }

    if (state.showDeleteFixedProductDialog && state.selectedFixedProductSet!=null){
        DeleteDialog(
            title = Strings.current().delete,
            description = Strings.current().doYouWantToRemove+" "
                + state.selectedFixedProductSet?.code,
            loading = state.deleteFixedProductLoading,
            windowSizeMode=windowSizeMode,
            onDismissDialog = {
                event(ProductEvent.SetDeleteFixedProductDialogStatus(false))
            },
            onSubmitClick = {
                event(ProductEvent.DeleteFixedProductSet)
            }
        )
    }

    if (state.showAddPriceDialog){
        AddPriceDialog(
            loading=state.createSpecialPriceLoading,
            createSpecialPrice ={name:String,startDate:String,startTime:String,type:Int->
                event(ProductEvent.CreateSpecialPrice(
                    name = name,
                    dateFrom = startDate,
                    startTime=startTime,
                    type = type,
                ))
            },
            onDismissDialog = {
                event(ProductEvent.SetAddPriceDialogStatus(false))
            }
        )
    }

    if (state.showCreateNewProductSetDialog){
        AddNewProductSetDialog(
            title = Strings.current().addNewSelection,
            templateCategories = state.templateCategoryList,
            loading = state.createNewProductSetLoading,
            onDismissDialog = {
                event(ProductEvent.SetCreateNewProductSetDialogStatus(false))
            },
            addNewProductSets={
                event(ProductEvent.AddProductSets(
                    categoryId=it
                ))
            }
        )
    }

    if (state.showAddProductFixDialog){
        AddOrEditFixedProductDialog(
            title = Strings.current().add,
            articles=state.productsInfo,
            selectedFixedProduct = null,
            loading = state.submitAddEditProductFixLoading,
            onDismissDialog = {
                event(ProductEvent.SetAddProductFixDialogStatus(false))
            },
            submit = { productId: String, price: Double?, quantity: Int ->
                    event(
                        ProductEvent.AddFixedProductSet(
                            productId = productId,
                            price = price,
                            quantity = quantity,
                        )
                    )
                }
        )

    }

    if (state.showEditProductFixDialog){

        AddOrEditFixedProductDialog(
            title = Strings.current().edit,
            articles=state.productsInfo,
            selectedFixedProduct=state.selectedFixedProductSet,
            loading = state.submitAddEditProductFixLoading,
            submit = {productId:String,price:Double?,quantity:Int->
                event(
                    ProductEvent.EditFixedProductSet(
                        productId=productId,
                        price=price,
                        quantity=quantity,
                    )
                )
            },
            onDismissDialog = {
                event(ProductEvent.SetEditProductFixDialogStatus(false))
            },

        )
    }

    if (state.showDeletePriceDialog){
        DeleteDialog(
            windowSizeMode = windowSizeMode,
            title =Strings.current().delete,
            description = Strings.current().doYouWantToRemove+
            " "+state.selectedPrice?.name,
            loading = state.deletePriceLoading,
            onDismissDialog = {
                event(ProductEvent.SetDeletePriceDialogStatus(false))
            },
            onSubmitClick = {
                event(ProductEvent.DeleteSpecialPrice)
            }

        )
    }

    if (state.showDeleteProductSetDialog){
        DeleteDialog(
            windowSizeMode = windowSizeMode,
            title =Strings.current().delete,
            description = Strings.current().doYouWantToRemove+
                    " "+state.selectedProductSet?.category?.name,
            loading = state.deleteProductSetLoading,
            onDismissDialog = {
                event(ProductEvent.SetDeleteProductSetDialogStatus(false))
            },
            onSubmitClick = {
                event(ProductEvent.DeleteProductSets)
            }

        )
    }

    if (state.showAddNewAlergeneComponent && windowSizeMode!=WindowSizeModeEnum.Desktop){
        AddingCustomAllergeneDialog(
            windowSizeMode=windowSizeMode,
            ingredients = state.ingredients,
            checkedIngredients = state.checkedIngredients,
            showCustomAllergenDialogStatus = {
                event(ProductEvent.SetCreateCustomAlergeneDialogStatus(it))
            },
            setCreateAllergenComponentStatus = {
                event(ProductEvent.SetCreateAlergeneComponentStatus(it))
            },
            onCancelClick={
                event(ProductEvent.SetCreateAlergeneComponentStatus(false))
            },
            updateAllergenData = { content, ingredientId ->
                event(ProductEvent.UpdateAllergenContent(
                    content = content,
                    ingredientId = ingredientId
                ))
            },
        )
    }

    if (state.showDeleteKitchenItemDialog){
        DeleteDialog(
            title = Strings.current().delete,
            description = Strings.current().doYouWantToRemove
                +" " + state.selectedKitchenInfoItem?.name+"?",
            windowSizeMode=windowSizeMode,
            loading =state.deleteKitchenItemLoading,
            onDismissDialog = {
                event(ProductEvent.DismissDeleteKitchenInfoDialogStatus)
            },
            onSubmitClick = {
                event(ProductEvent.DeleteKitchenInfo(
                    id =state.selectedKitchenInfoItem?.id?:""
                ))
            }
        )
    }

    if (state.showAddRecordDialog) {
        AddRecordDialog(
            windowSizeMode = windowSizeMode,
            dialogTitle = Strings.current().creatingNewProduct,
            nameFieldTitle = Strings.current().name,
            numberFieldTitle = Strings.current().number,
            nameValue = state.newRecordName,
            showNumberField = true,
            numberValue = state.newRecordNumber,
            isSubmitClickable = state.isAddNewRecordSubmitClickable,
            loading = state.addNewProductLoadingProgressBar,
            nameHint =Strings.current().enterProductName,
            numberHint = Strings.current().enterProductNumber,
            onNumberValueChange = {
                event(ProductEvent.OnChangeRecordNumber(it))
            },
            onNameValueChange = {
                event(ProductEvent.OnChangeRecordName(it))
            },
            onCancelClick = {
                event(ProductEvent.OnCancelRecordDialogClick)
            },
            onSubmitClick = {
                event(ProductEvent.OnSubmitAddRecordDialogClick(windowSizeMode))
            },
            onBackgroundClick = {
                event(ProductEvent.OnCancelRecordDialogClick)
            }
        )
    }

    if (state.showKitchenAddOrEditItemDialog){
        KitchenAddItemDialog(
            selectedItem=state.selectedKitchenInfoItem,
            windowSizeMode=windowSizeMode,
            loading = state.kitchenInfoDialogLoading,
            onCancelClick = {
                event(ProductEvent.OnCancelKitchenItemDialog)
            },
            onSubmitClick={name:String,variants:List<String?> ->
                event(ProductEvent.OnSubmitKitchenInfoDialog(
                    id = state.selectedKitchenInfoItem?.id?:"",
                    name=name,
                    variants=variants,
                ))
            },
        )
    }

    if (state.showCreateCustomAllergeneDialog)
    {
        CreateCustomAllergeneDialog(
            createCustomAllergeneLoading=state.createCustomAllergeneLoading,
            onCancelClick = {
                event(ProductEvent.SetCreateCustomAlergeneDialogStatus(false))
            },
            createCustomAllergen = { name, unit, number, keyword ->
                event(
                    ProductEvent.CreateProductIngredients(
                        name = name,
                        unit = unit,
                        number = number,
                        keyword = keyword
                    )
                )
            }
        )

    }



    if (state.errorInfo!=null){
        ErrorMsgDialog(
            windowSizeMode = windowSizeMode,
            description =state.errorInfo,
            onDismissDialog = {
                event(ProductEvent.DismissErrorDialog)
            }
        )
    }


}
